import { HTTP } from '@/services/axios';

export async function getArticles({filterText,filterCategory,orderCol,orderSort,page,records}){
    let result = {};
    
    await HTTP.get('/app/core/Article/getArticleList.php',{
        params:{
            filterText,
            filterCategory,
            orderCol,
            orderSort,
            page,
            records
        }
    })
    .then(response => {
        result = response.data;
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getArticle({articleId}){
    let result = {};

    await HTTP({
        method: 'get',
        url: `/app/core/Article/getArticleData.php?articleId=${articleId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function unlockArticle({articleId}){
    let result = {};

    await HTTP({
        method: 'patch',
        url: '/app/core/Article/controlArticleUnlock.php',
        data: articleId
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function changeStateArticle({articleId,state}){
    let result = {};
    var data = {'articleId':articleId,'state':state}
        
    await HTTP({
        method: 'patch',
        url: '/app/core/Article/controlArticleChangeState.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function reOrderArticle({removedIndex1,addedIndex1,idItemRemove,orderingItemAdded}){
    let result = {};
   
    var orderingItem = orderingItemAdded;
    //idem hore
    if(removedIndex1 > addedIndex1){
        orderingItem = orderingItemAdded + 1;
    }

    //idem dole
    if(removedIndex1 < addedIndex1){
        orderingItem = orderingItemAdded - 1;
    }

    var data = {
        'removedIndex1':removedIndex1,
        'addedIndex1':addedIndex1,
        'idItemRemove':idItemRemove,
        'orderingItemAdded':orderingItem
    }
    
    await HTTP({
        method: 'patch',
        url: '/app/core/Article/controlArticleReOrder.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deleteArticle(article){
    let result = {};

    await HTTP({
        method: 'delete',
        url: '/app/core/Article/controlArticleDelete.php',
        data: article
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function createArticle(article){
    let result = {};

    await HTTP({
        method: 'post',
        url: '/app/core/Article/controlArticleSave.php',
        data: article
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveArticle(article){
    let result = {};

    await HTTP({
        method: 'put',
        url: '/app/core/Article/controlArticleSave.php',
        data: article
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

// ********** article components 
export async function getArticleComponents({articleId}){
    let result = {};

    await HTTP({
        method: 'get',
        url: `/app/core/Article/components/getArticleComponents.php?articleId=${articleId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function addComponentArticle({articleId,selectedComponentId}){
    let result = {};

    var data = {'componentId':selectedComponentId,'articleId':articleId}

    await HTTP({
        method: 'post',
        url: '/app/core/Article/components/controlComponentAdd.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveComponentArticle({content,id}){
    let result = {};

    var data = {
        'content':content,
        'componentId':id
    }
    
    await HTTP({
        method: 'put',
        url: '/app/core/Article/components/controlArticleSaveComponentContent.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deleteComponentArticle({componentId}){
    let result = {};

    var data = {'componentId':componentId}
   
    await HTTP({
        method: 'delete',
        url: '/app/core/Article/components/controlComponentDelete.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function orderUpComponentArticle({articleId,ordering,id}){
    let result = {};

    var data = {
        'currentOrdering':ordering,
        'componentId':id,
        'articleId':articleId
    }
    
    await HTTP({
        method: 'patch',
        url: '/app/core/Article/components/controlComponentOrderUp.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function orderDownComponentArticle({articleId,ordering,id}){
    let result = {};

    var data = {
        'currentOrdering':ordering,
        'componentId':id,
        'articleId':articleId
    }

    await HTTP({
        method: 'patch',
        url: '/app/core/Article/components/controlComponentOrderDown.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

